import { ronMediaArray } from './ronMedia'
import { ronBio } from './ronBios'

import { hermioneReviewerReviewHinge, dumbledoreReviewerReviewBumble, harryReviewerReviewTinder } from './ronReviewerReviews'
import { hermioneReviewerProfile, dumbledoreReviewerProfile, harryReviewerProfile } from './ronReviewers'

export const hermioneProfileReviewHinge = {
  _id: 'hermioneProfileReviewHingeId',
  userId: 'ronUserId',
  userEmail: 'ron@email.com',
  datingProfileId: 'ronDatingProfileHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  reviewerEmail: 'hermione@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Good photo, you've tricked a helpless soul who doesn't know you into thinking your good-looking and stylish`,
      verdict: 'Very',
    },
    {
      feedback: `The photo is a bit blurry, but the vibe is good — again you've done a fantastic job hiding your true self and looking here like a real romantic`,
      verdict: 'Yes',
    },
    {
      feedback: `I've literally never seen you so composed. Another great job hiding your true self`,
      verdict: 'Yes',
    },
    {
      feedback: `This is the Ron I know. Clumsy and scared. By the way, girls don't like rats`,
      verdict: 'No',
    },
    {
      feedback: `You're trying too hard here. How full of yourself are you. Come on`,
      verdict: 'Somewhat',
    },
    {
      feedback: `A little bit boring but at least you don't look clumsy`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You somehow manage to seem well put together and oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Again with the rats... girls don't swoon over rats Ron`,
        verdict: 'No', 
      },
      {
        feedback: `Bland... is there a guy in the world who doesn't like Quidditch?`,
        verdict: 'No', 
      },
      {
        feedback: `OK, I laughed`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Ron — according to his profile, is well-composed, dapper, and fun.`,
    good: `You hide your clumsiness and befuddlement quite effectively. Good job!`,
    notGood: `There are some unoriginal prompts, and the rat picture isn't attractive`,
    verdict: `Overall it's good. A few easy changes could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hermioneReviewerReviewHinge },
  reviewerProfile: { ...hermioneReviewerProfile },
  bioItems: { ...ronBio },
  mediaItems: [ ...ronMediaArray ],
}

export const dumbledoreProfileReviewBumble = {
  _id: 'dumbledoreProfileReviewBumbleId',
  userId: 'ronUserId',
  userEmail: 'ron@email.com',
  datingProfileId: 'ronDatingProfileBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  reviewerEmail: 'dumbledore@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Good photo, you've tricked a helpless soul who doesn't know you into thinking your good-looking and stylish`,
      verdict: 'Very',
    },
    {
      feedback: `The photo is a bit blurry, but the vibe is good — again you've done a fantastic job hiding your true self and looking here like a real romantic`,
      verdict: 'Yes',
    },
    {
      feedback: `I've literally never seen you so composed. Another great job hiding your true self`,
      verdict: 'Yes',
    },
    {
      feedback: `This is the Ron I know. Clumsy and scared. By the way, girls don't like rats`,
      verdict: 'No',
    },
    {
      feedback: `You're trying too hard here. How full of yourself are you. Come on`,
      verdict: 'Somewhat',
    },
    {
      feedback: `A little bit boring but at least you don't look clumsy`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: ronBio.aboutMe[0],
    hobbies: [ronBio.hobbies[0], ronBio.hobbies[1], ronBio.hobbies[2], ronBio.hobbies[3], ronBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You somehow manage to seem well put together and oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'OK, this is funny, I admit it',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Again with the rats... girls don't swoon over rats Ron`,
        verdict: 'No', 
      },
      {
        feedback: `Bland... is there a guy in the world who doesn't like Quidditch?`,
        verdict: 'No', 
      },
      {
        feedback: `OK, I laughed`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Ron — according to his profile, is well-composed, dapper, and fun.`,
    good: `You hide your clumsiness and befuddlement quite effectively. Good job!`,
    notGood: `There are some unoriginal prompts, and the rat picture isn't attractive`,
    verdict: `Overall it's good. A few easy changes could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...dumbledoreReviewerReviewBumble },
  reviewerProfile: { ...dumbledoreReviewerProfile },
  bioItems: { ...ronBio },
  mediaItems: [ ...ronMediaArray ],
}

export const harryProfileReviewTinder = {
  _id: 'harryProfileReviewTinderId',
  userId: 'ronUserId',
  userEmail: 'ron@email.com',
  datingProfileId: 'ronDatingProfileTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  reviewerEmail: 'harry@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: ronMediaArray[7]._id,
      mediaItemURL: ronMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[7].type,
      caption: ronMediaArray[7].captions[0],
      subcaption: ronMediaArray[7].subcaptions[2],
    },
    {
      mediaItemId: ronMediaArray[1]._id,
      mediaItemURL: ronMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[1].type,
      caption: ronMediaArray[1].captions[0],
      subcaption: ronMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[6]._id,
      mediaItemURL: ronMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[6].type,
      caption: ronMediaArray[6].captions[0],
      subcaption: ronMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[14]._id,
      mediaItemURL: ronMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[14].type,
      caption: ronMediaArray[14].captions[2],
      subcaption: ronMediaArray[14].subcaptions[0],
    },
    {
      mediaItemId: ronMediaArray[4]._id,
      mediaItemURL: ronMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[4].type,
      caption: ronMediaArray[4].captions[2],
      subcaption: ronMediaArray[4].subcaptions[1],
    },
    {
      mediaItemId: ronMediaArray[10]._id,
      mediaItemURL: ronMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: ronMediaArray[10].type,
      caption: ronMediaArray[10].captions[0],
      subcaption: ronMediaArray[10].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Good photo, you've tricked a helpless soul who doesn't know you into thinking your good-looking and stylish`,
      verdict: 'Very',
    },
    {
      feedback: `The photo is a bit blurry, but the vibe is good — again you've done a fantastic job hiding your true self and looking here like a real romantic`,
      verdict: 'Yes',
    },
    {
      feedback: `I've literally never seen you so composed. Another great job hiding your true self`,
      verdict: 'Yes',
    },
    {
      feedback: `This is the Ron I know. Clumsy and scared. By the way, girls don't like rats`,
      verdict: 'No',
    },
    {
      feedback: `You're trying too hard here. How full of yourself are you. Come on`,
      verdict: 'Somewhat',
    },
    {
      feedback: `A little bit boring but at least you don't look clumsy`,
      verdict: 'Somewhat',
    }
  ],
  bio: {
    bioItemsId: ronBio._id,
    vitalInfo: { ...ronBio.vitalInfo },
    prompts: [
      { ...ronBio.prompts[0] },
      { ...ronBio.prompts[1] },
      { ...ronBio.prompts[2] }
    ],
    aboutMe: ronBio.aboutMe[0],
    hobbies: [ronBio.hobbies[0], ronBio.hobbies[1], ronBio.hobbies[2], ronBio.hobbies[3], ronBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You somehow manage to seem well put together and oriented`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'OK, this is funny, I admit it',
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Again with the rats... girls don't swoon over rats Ron`,
        verdict: 'No', 
      },
      {
        feedback: `Bland... is there a guy in the world who doesn't like Quidditch?`,
        verdict: 'No', 
      },
      {
        feedback: `OK, I laughed`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Ron — according to his profile, is well-composed, dapper, and fun.`,
    good: `You hide your clumsiness and befuddlement quite effectively. Good job!`,
    notGood: `There are some unoriginal prompts, and the rat picture isn't attractive`,
    verdict: `Overall it's good. A few easy changes could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...harryReviewerReviewTinder },
  reviewerProfile: { ...harryReviewerProfile },
  bioItems: { ...ronBio },
  mediaItems: [ ...ronMediaArray ],
}